import { TEXTS, currentLang } from "./i18n";

/** The browsers built into social apps (Facebook, Messenger, Instagram...): they keep their own storage and limit audio, fullscreen and gamepads. */
export const IN_APP_RE = /FBAN|FBAV|FB_IAB|FBIOS|FB4A|Messenger|Instagram|TikTok|musical_ly|BytedanceWebview|Snapchat|LinkedInApp|Pinterest|MicroMessenger|Line\//i;
export const detectInApp = (ua: string) => IN_APP_RE.test(ua);

/** A dismissible banner that explains how to open the game in the real browser (Android: a button that tries to open Chrome). */
export function initInAppBanner() {
  const force = /[?&]iab=1\b/.test(location.search); // for testing
  if (!force && !detectInApp(navigator.userAgent)) return;
  try {
    if (!force && Date.now() - Number(localStorage.getItem("f1iab") ?? 0) < 86_400_000) return; // closed less than a day ago
  } catch {
    /* storage unavailable: show it */
  }
  const android = /Android/i.test(navigator.userAgent);
  const t = () => TEXTS[currentLang()];
  const bar = document.createElement("div");
  bar.id = "iab";
  bar.style.cssText = "position:fixed;top:0;left:0;right:0;z-index:30;padding:8px 10px;background:#e0f8d0;color:#081820;border-bottom:3px solid #346856;font:12px/1.35 monospace;-webkit-user-select:text;user-select:text";
  const msg = document.createElement("div");
  const row = document.createElement("div");
  row.style.cssText = "display:flex;gap:6px;margin-top:6px;flex-wrap:wrap;align-items:center";
  const btn = (label: () => string, on: () => void) => {
    const b = document.createElement("button");
    b.style.cssText = "font:bold 12px monospace;padding:6px 10px;border:2px solid #346856;border-radius:8px;background:#081820;color:#e0f8d0";
    b.textContent = label();
    b.addEventListener("click", on);
    row.appendChild(b);
    return b;
  };
  const fill = () => {
    msg.textContent = t().iabMsg + (android ? "" : " " + t().iabIos);
  };
  fill();
  if (android) {
    btn(() => t().iabChrome, () => {
      location.href = `intent://${location.host}${location.pathname}${location.search}#Intent;scheme=${location.protocol.replace(":", "")};package=com.android.chrome;end`;
    });
  }
  const link = location.origin + location.pathname;
  const copy = btn(() => t().iabCopy, () => {
    navigator.clipboard.writeText(link).then(
      () => ((copy.textContent = t().iabCopied), void 0),
      () => ((copy.textContent = link), void 0), // clipboard refused: show the link to copy by hand
    );
  });
  btn(() => t().iabClose, () => {
    try {
      localStorage.setItem("f1iab", String(Date.now()));
    } catch {
      /* ignore */
    }
    bar.remove();
  });
  bar.append(msg, row);
  document.body.appendChild(bar);
  // follows the FR/EN toggle
  document.querySelectorAll("[data-lang-toggle]").forEach((el) => el.addEventListener("click", () => setTimeout(() => {
    fill();
    const bs = row.querySelectorAll("button");
    const labels = android ? [t().iabChrome, t().iabCopy, t().iabClose] : [t().iabCopy, t().iabClose];
    bs.forEach((b, i) => { if (labels[i] && b.textContent !== link) b.textContent = labels[i]; });
  }, 0)));
}
